
<div class="d-flex " 
 >
  <div class="mr-4"> <label class=" font" [for]="props.id">{{ props.label }}</label>
  </div>
  
</div>